import React, { useState } from 'react'
import * as basket from '../basket-utils'
import { toast } from 'react-toastify'

const PromotionCodes = ({ promotions = [], basketToken, setOrderData }) => {
    const [promoCode, setPromoCode] = useState('')

    const onAddPromoCode = async promoCode => {
        const basketPromotions = promotions.map(promo => promo?.promotionCode)
        try {
            const { data } = await basket.addPromotionCodesToBasket({
                basketId: basketToken,
                promoCodes: [...basketPromotions, promoCode],
            })

            setOrderData(data)

            toast.success(`Promotion code applied to this order`)

            setPromoCode('')
        } catch (e) {
            if (e?.response) {
                const { data } = e.response
                console.error(e)
                toast.error(
                    data?.hasOwnProperty('hydra:description')
                        ? data['hydra:description']
                        : 'Whoops, there was a problem...'
                )
            }
        }
    }

    return (
        <div className="row">
            <div className="col-12 col-lg-6">
                <div className="!flex !items-center !h-full">
                    <p className="!mb-0">Add Promotion Codes:</p>
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="!flex">
                    <input
                        type="text"
                        className="form-control !mr-2"
                        onChange={e => setPromoCode(e.target.value)}
                        onKeyDown={e => {
                            if (e.keyCode === 13 || e.which === 13) {
                                onAddPromoCode(promoCode)
                            }
                        }}
                        value={promoCode}
                        placeholder="Promotion Code"
                    />

                    <button
                        className="btn btn-success"
                        onClick={() => {
                            onAddPromoCode(promoCode)
                            setPromoCode('')
                        }}
                    >
                        Add
                    </button>
                </div>
            </div>
        </div>
    )
}

export default PromotionCodes
